module.exports = __webpack_public_path__ + "static/report-542bbb547da199af4462e83f8c421aef.svg";